import React from 'react'
import Icon from './Icons'
import { useSearchModalStore } from '@forwardflow/store/modal'
type SearchFieldProps = {
   disabled?: boolean
   className?: string
   onclick?: () => void
   onSearchClick?: () => void
   placeholder?: string
   iconClassName?: string
   value?: string
   onChange?: (value: string) => void
   handleClick?: () => void
   viewSearchBtn?: boolean
}

export const SearchField: React.FC<SearchFieldProps> = ({
   className,
   placeholder = 'Search for agents, teams, leads or campaigns',
   iconClassName = 'fill-white/30',
   value,
   onChange,
   onSearchClick,
   handleClick,
   viewSearchBtn = false,
}) => {
   const { openSearchModal } = useSearchModalStore()
   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value)
   }
   return (
      <div
         onClick={openSearchModal}
         className={` ${className} flex items-center rounded-full justify-center h-[52px] bg-[#303137] max-w-[440px] lg:w-full xl:max-w-[680px] outline-none overflow-hidden`}
      >
         <label htmlFor="ff-search-field">
            <Icon
               name="search"
               className={`px-4 ${iconClassName} cursor-pointer`}
            />
         </label>

         <div className="flex-1">
            <input
               type="text"
               id="ff-search-field"
               className="w-full bg-transparent outline-none"
               value={value}
               autoComplete="off"
               placeholder={placeholder}
               onChange={handleChange}
               onClick={handleClick}
            />
         </div>
         {viewSearchBtn && (
            <button
               onClick={onSearchClick}
               className="bg-[#414246] h-full w-[120px]"
            >
               Search
            </button>
         )}
      </div>
   )
}
